import { find, register } from '../../../../Javascript/Sysmex/Utils'

const iframe = el => {
  const hasControls = el.dataset.hascontrols
  const componentPrefix = el.dataset.componentprefix
  const targetURL = el.dataset.url
  const scrollTarget = el.dataset.scrolltarget
  const zoomTarget = el.dataset.zoomtarget
  const iframe = find(`.${componentPrefix}iFrameWindow`, el)

  /* check if controls are activated */
  if (hasControls) {
    /* wait for vital sign from iFrame script, then init component and send init order + params to iFrame */
    window.addEventListener('message', (e) => {
      if (e.data === 'init' && targetURL.includes(e.origin)) {
        initControls()
        iframe.contentWindow.postMessage({
          type: 'init',
          scrollTarget: scrollTarget,
          zoomTarget: zoomTarget
        }, targetURL)
      }
    })
  }

  /* initialize controls */
  const initControls = () => {
    const btnZoomIn = find(`.${componentPrefix}zoomIn`, el)
    const btnZoomOut = find(`.${componentPrefix}zoomOut`, el)

    /* send zoom-in signal to iFrame script at button click */
    btnZoomIn.addEventListener('click', (e) => {
      e.preventDefault()
      iframe.contentWindow.postMessage({
        type: 'rescale',
        value: 1.2
      }, targetURL)
    })

    /* send zoom-out signal to iFrame script at button click */
    btnZoomOut.addEventListener('click', (e) => {
      e.preventDefault()
      iframe.contentWindow.postMessage({
        type: 'rescale',
        value: 0.8
      }, targetURL)
    })
  }
}

register('iframe', iframe)
